/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit AddAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFormat from 'Simple/Data/format.js'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaButtonWithText from 'DesignSystem/TysiaButtonWithText/index'



/** @type {import('Simple/types.js').View} */
export default function AddAction({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/ContactInfo/Email/Emails/Content/Email/Address/Related/Content/Popup/Content/Persons/Person/Relation/Empty/Content/AddAction"
  
}) {
let relationshipValueData = fromData.useDataFormat({ viewPath,
context: 'relationship',
format: fromFormat.not,
})
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<TysiaButtonWithText
  viewPath={`${viewPath}/TysiaButtonWithText`}
 onClick={onClick}
 data="relationship"
 format="/Simple/Data/format.js not"
 disabled={relationshipValueData}
 text="Add"
/>
{children}
</React.Fragment>)
}